import React from 'react';
import { Tooltip } from 'react-tooltip';
//components
import { Visibility } from 'components/Visibility';
import { Content } from './styles';
//assets
import refrigeratedIcon from 'img/icon-refrigerated.svg';
//generics
import { IRefrigeratedTag } from '../interface';
import { generateRandomId } from 'utils/GenerateRandomId';


export const RefrigeratedTag: React.FC<IRefrigeratedTag> = (props) => {
  const { refrigerated } = props;
  const tooltipId = generateRandomId("TooltipAutoAnswerOl");

  return (
    <Content>
      <Visibility visible={refrigerated}>
        <img src={refrigeratedIcon} alt="tag refrigerado" data-tooltip-id={tooltipId} data-tooltip-content="Produto refrigerado" />
        <Tooltip id={tooltipId} variant="light" />
      </Visibility>
    </Content>
  );
};